import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb"; //Breadcrumb
import Accordion from "react-bootstrap/Accordion"; //Accordion
import AccordionData from "../data/AccordionData"; //AccordionData
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import "../Components/Footer.css"; //Footer.css
import exchange from "../assets/images/exchange.png";
import shippping from "../assets/images/shippping.png";
import Rupee from "../assets/images/Rupee.png";
import exp from "../assets/images/exp.png";

import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/styles.min.css";

import "./ProductDetail.css";

import StarPurple500OutlinedIcon from "@mui/icons-material/StarPurple500Outlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";

import img1 from "../assets/images/detail1.png";
import img2 from "../assets/images/detail2.png";
import img3 from "../assets/images/detail3.png";
import img4 from "../assets/images/detail4.png";

import Facebook from "../assets/images/Facebook.png";
import Instagram from "../assets/images/Instagram.png";
import Whatsapp from "../assets/images/Whatsapp.png";
import Call from "../assets/images/Call.png";

import colorpillows from "../assets/images/carpet.png";

import CartSidebar from "../Components/CartSidebar";

export default function DetailInfo() {
  const images = [img1, img2, img3, img4];
  const [mainImg, setMainImg] = useState(images[0]);

  const { id } = useParams();

  const [counter, setCounter] = useState(1);

  const inc = () => {
    setCounter(counter + 1);
  };

  const dec = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

   const [cartOpen, setCartOpen] = useState(false);

  return (
    <div className="detail-outer">
      <div className="container-fluid">
        <div className="breadcrumb_title detail_page_breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
            <Breadcrumb.Item href="/products">16x16 Inches </Breadcrumb.Item>
            <Breadcrumb.Item active>
              Nazakat Hand Woven Beige Cotton Cushion Cover
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="inner-detail">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="img-section-detail">
                <div className="gallery">
                  {/* left side */}
                  <div className="thumbnails">
                    {images.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt=""
                        onClick={() => setMainImg(img)}
                        className={`thumb ${mainImg === img ? "active" : ""}`}
                      />
                    ))}
                  </div>

                  {/* right side */}
                  
                  <div className="main-image">
                    {/* <img src={mainImg} alt="" /> */}

                    <InnerImageZoom
                    src={mainImg}
                    zoomSrc={mainImg}
                  />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <div className="text-section-detail">
                <h1 className="detail-heading">
                  Nazakat Hand Woven Beige Cotton Cushion Cover
                </h1>
                <div className="star_review">
                  <div className="stars">
                    <StarPurple500OutlinedIcon />
                    <StarPurple500OutlinedIcon />
                    <StarPurple500OutlinedIcon />
                    <StarPurple500OutlinedIcon />
                    <StarPurple500OutlinedIcon />
                  </div>

                  <p className="starpera">(1k+ Total Reviews)</p>
                </div>

                <p className="code-in-detail">SKU: CU03970001_1.04x1.04</p>
                <div class="price-section">
                  <span class="old-price">₹ 5,000.00</span>
                  <span class="new-price">₹ 3,250.00</span>
                  <span class="discount-badge">You saved 35%</span>
                  <span class="tax-text">(MRP incl. of all taxes)</span>
                </div>
              </div>

              <div className="color-section">
                <p>Color :</p>
                <div className="color-box">
                  <div className="main-color-box">
                    <img src={colorpillows} alt="" />
                  </div>
                  <div className="main-color-box">
                    <img src={colorpillows} alt="" />
                  </div>
                  <div className="main-color-box">
                    <img src={colorpillows} alt="" />
                  </div>
                  <div className="main-color-box">
                    <img src={colorpillows} alt="" />
                  </div>
                </div>
              </div>

              <div class="size-section">
                <p class="size-title">Size :</p>

                <div class="size-options">
                  <div class="size-box active">
                    <span>18 x 18 Inches</span>
                    <small>46 x 46 cm</small>
                  </div>

                  <div class="size-box disabled">
                    <span>18 x 18 Inches</span>
                    <small>46 x 46 cm</small>
                  </div>

                  <div class="size-box disabled">
                    <span>18 x 18 Inches</span>
                    <small>46 x 46 cm</small>
                  </div>
                </div>
              </div>

              <div className="counter_add_cart_section">
                <div className="counter">
                  <button onClick={dec}>-</button>
                  <p className="number">{counter}</p>
                  <button onClick={inc}>+</button>
                </div>

                <div className="add_cart_btn">
                  <button  onClick={() => setCartOpen(!cartOpen)}>Add To Cart</button>
                </div>

                <CartSidebar cartOpen={cartOpen} setCartOpen={setCartOpen} />

                <div className="wishlist_btn">
                  <button>
                    <FavoriteBorderOutlinedIcon />
                  </button>
                </div>
              </div>

              <div className="color-section">
                <p>Share :</p>
                <div className="social_share">
                 <div className="social_icons">
                <ul>
                  <li>
                    <a href="#">
                      <img src={Facebook} alt="" className="img-fluid"/> 
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={Instagram} alt="" className="img-fluid"/>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={Whatsapp} alt="" className="img-fluid"/>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={Call} alt="" className="img-fluid"/>
                    </a>
                  </li>
                </ul>
              </div>
                </div>
              </div>

            <div className="shipping_feature">
              <div className="eachange_outer">
                <img src={exchange} alt="" />
                <p>Easy Exchange</p>
              </div>

              <div className="eachange_outer">
                <img src={Rupee} alt="" />
                <p>COD Avaliable</p>
              </div>

              <div className="eachange_outer">
                <img src={shippping} alt="" />
                <p>Free Shipping</p>
              </div>

              <div className="eachange_outer">
                <img src={exp} alt="" />
                <p>20+yers of Experience</p>
              </div>
            </div>

              <div className="detail_accord">
                <Accordion defaultActiveKey="0">
                  {AccordionData.map((item) => (
                    <Accordion.Item eventKey={item.id.toString()} key={item.id}>
                      <Accordion.Header>{item.title}</Accordion.Header>
                      <Accordion.Body>{item.content}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
